<template>
  <!-- 商城首页 -->
  <div class="content">
    <div class="center">
      <div class="header">
        <van-search
          class="search"
          placeholder="请输入搜索关键词"
          readonly
          @click="$router.push('/search')" 
          v-model="value"
          background="#E8E8E8"
          shape="round"
        />
        <div class="icon">
          <van-badge :content="cartNum > 0 ? cartNum : ''">
            <van-icon
              @click="buyCart()"
              name="shopping-cart-o"
              size="0.64rem"
              color="#333333"
            />
          </van-badge>
          <van-icon
            class="myIcon"
            color="#333333"
            @click="myMall()"
            name="contact"
            size="0.64rem"
          />
        </div>
      </div>
      <!-- 内容 -->
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <!-- 轮播 -->
        <div class="swipers">
          <van-skeleton :row="1" row-width="345" :loading="loading">
            <van-swipe :autoplay="3000">
              <van-swipe-item
                v-for="item in images"
                @click="toProduct(item.product_id)"
                :key="item.id"
              >
                <img v-lazy="item.imageUrl" />
              </van-swipe-item>
            </van-swipe>
          </van-skeleton>
        </div>
        <!-- 获取活动商品 -->
        <ul
          v-for="item in activityProductList"
          @click="toShopping(item.productList[0].id)"
          :key="item.id"
          class="activityProductInfo"
        >
          <li v-if="isShow">
            <div class="activityProduct">
              <div class="activityProductImg">
                <img
                  v-if="item.productList[0].length"
                  :src="item.productList[0].productActivityImg"
                  alt=""
                />
              </div>
            </div>
          </li>
        </ul>
        <!-- 新品速递 -->
        <h4 class="h4" v-if="activityProduct.length">
          <van-skeleton :row="1" row-width="65" :loading="loading">
            新品速递
            <span @click="$router.push('/recommend')"
              >更多<van-icon name="arrow"
            /></span>
          </van-skeleton>
        </h4>
        <ul class="newProductTop">
          <li
            class="newProduct"
            v-for="item in activityProduct"
            :key="item.id"
            @click="getProductInfo(item.goods_id)"
          >
            <div class="productImg"><img :src="item.image_url" alt="" /></div>
            <div class="productText">
              <p class="p1">{{ item.goods_name }}</p>
              <p class="p2">{{item.goods_desc}}</p>
              <span>￥{{ item.outer_goods_price }}</span>
            </div>
            <div class="btn">立即抢购</div>
          </li>
        </ul>
        <!-- 精品优选 -->
        <h4 class="h4" v-if="allProductList.length">精品优选</h4>
        <div class="productList">
          <ul>
            <li
              v-for="item in this.allProductList"
              @click="toShopping(item.goods_id)"
              :key="item.id"
            >
              <div class="productImg">
                <img v-lazy="item.img_url" alt="" />
              </div>
              <div class="proName">
                <p class="p1">{{ item.goods_name }}</p>
                <p class="p2">{{item.goods_desc}}</p>
                <span class="money"
                  >￥{{ Number(item.outer_goods_price).toFixed(2) }}</span
                >
              </div>
            </li>
          </ul>
        </div>
      </van-pull-refresh>
    </div>
    <van-loading
      v-show="LoadingShow"
      type="spinner"
      size="1rem"
      color="#1989fa"
      vertical
      >加载中</van-loading
    >
  </div>
</template>
<script>
import { Toast } from "vant";
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      img: require("../../assets/img/appHome/编组 4@2x.png"),
      isLoading: false,
      value: "",
      LoadingShow: false,
      images: [],
      show: true,
      activityProduct: [],
      activityProductList: [],
      allProductList: {},
      isFirstEnter: false,
      isShow: true,
      cartNum: "",
      cell: "",
      loading: true,
    };
  },
  created() {
    // 用来让安卓和苹果ios调用传递token和userId的方法 str接收
    window["callJsFunction"] = this.callJsFunction;
    // this.isFirstEnter = true;
    // 调用获取轮播图的方法
    this.getSwipe();
    // 获取token后调用获取产品分类的方法
    this.getShoppingCart();
    this.getActivityClass();
    this.getProductList();
    this.getActivityProduct();
  },
  methods: {
    // 传过来token和userId的回调
    callJsFunction(str) {
      // 判断设备系统的函数
      let phone = checkDevice();
      if (phone == "ios") {
        sessionStorage.setItem("CONFIDENTIAL", str);
        let exclusive = str.slice(37);
        sessionStorage.setItem("EXCLUSIVE", exclusive);
        this.getShoppingCart();
      } else {
        sessionStorage.setItem("CONFIDENTIAL", str);
        let exclusive = str.slice(33);
        sessionStorage.setItem("EXCLUSIVE", exclusive);
        this.getShoppingCart();
      }
    },
    // 获取轮播图的数据
    async getSwipe() {
      await this.$post({
        url: "/owsAppRoundPic/findAppRoundPic",
        method: "post",
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.images = res.data.code;
            this.loading=false
          } else {
            // this.$toast({ message: "加载失败", icon: "close" });
          }
        })
        .catch((err) => {});
    },
    // 获取购物车里的商品
    getShoppingCart() {
      if (
        sessionStorage.getItem("EXCLUSIVE") == null ||
        sessionStorage.getItem("EXCLUSIVE") == ""
      ) {
        return;
      } else {
        this.$post({
          url: "/osc/findOmsShoppingCartAll",
          method: "post",
          params: {
            userId: sessionStorage.getItem("EXCLUSIVE"),
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              this.cartNum = res.data.code.length;
            }
          })
          .catch((err) => {
            this.$toast("加载失败");
          });
      }
    },
    // 获取商品列表
    async getProductList() {
      await this.$post({
        url: "/owsProductInfo/findProductInfo",
        method: "post",
        params: {
          // userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.allProductList = res.data.code;
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 获取产品分类
    async ProductClassification() {
      const res = await this.$post({
        url: "/owsProductInfo/owsProductTypeInfo",
        method: "post",
        params: {
          // userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.productClassList = res.data.code;
          }
        })
        .catch((err) => {});
    },
    // 获取活动商品
    async getActivityProduct() {
      await this.$post({
        url: "/owsProductInfo/findActivityProductsAll",
        method: "post",
      })
        .then((res) => {
          if (res.retCode == 200) {
            if (res.data.length == 0) {
              this.isShow = false;
            } else {
              this.activityProductList = res.data.filter((item) => {
                return item.productList.length !== 0;
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取新品推荐商品
    async getActivityClass() {
      await this.$post({
        url: "/owsProductInfo/findActivityProducts",
        method: "post",
        params: {
          // userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.activityProduct = res.data.code.slice(0, 2);
            sessionStorage.setItem("P_ID", this.activityProduct.id);
          }
        })
        .catch((err) => {});
    },
    // 新品速递  点击跳转到详情
    getProductInfo(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push({
        path: "/toShopping",
      });
    },
    // 点击轮播图跳转
    toProduct(id) {
      this.$router.push("/toShopping");
      sessionStorage.setItem("P_ID", id);
    },
    // 进入购物车
    buyCart() {
      let phone = checkDevice();
      // this.$router.push("/buyCart");
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        if (phone == "android") {
          window.jsCallAndroid.jsCallUnLoginFunction(); //调用安卓的api跳转到未登录页面
        } else if (phone == "ios") {
          window.webkit.messageHandlers.UnLogin.postMessage(""); //调用ios的api
        }
      } else {
        this.$router.push("/buyCart");
      }
    },
    // 进入我的商城
    myMall() {
      let phone = checkDevice();
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        if (phone == "android") {
          window.jsCallAndroid.jsCallUnLoginFunction(); //调用安卓的api跳转到未登录页面
        } else if (phone == "ios") {
          window.webkit.messageHandlers.UnLogin.postMessage(""); //调用ios的api
        }
      } else {
        this.$router.push("/personalCenter");
      }
    },
    // 跳转到商品详情
    toShopping(id) {
      this.$router.push("/toShopping");
      sessionStorage.setItem("P_ID", id);
    },
    // 刷新
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.getSwipe();
        this.getShoppingCart();
        this.ProductClassification();
        this.getActivityClass();
        this.getProductList();
        this.getActivityProduct();
      }, 1500);
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  background-color: #e8e8e8;
  .center {
    background-size: 100%;
    .h4 {
      margin: 0.4rem 0.4rem;
      overflow: hidden;
      span {
        float: right;
        display: flex;
        align-items: center;
        font-size: 0.32rem;
        font-weight: 400;
        color: #666666;
        /deep/.van-icon {
          font-size: 0.373333rem;
        }
      }
    }
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 0.4rem;
      z-index: 99;
      background-color: #e8e8e8;
      .search {
        width: 7.8rem;
        color: #333333;
      }
      .icon {
        display: flex;
        align-items: center;
        .myIcon {
          padding: 0 0.373333rem;
        }
      }
    }
    .swipers {
      margin-top: 1.493333rem;
      margin: 0 auto;
      width: 9.2rem;
      height: 4.266667rem;
      overflow: hidden;
      border-radius: 0.2rem;
      .van-skeleton__row {
        height: 4.2667rem;
        overflow: hidden;
      }

      img {
        width: 9.2rem;
        height: auto;
      }
    }
    .activityProductInfo {
      width: 9.2rem;
      margin: 0.4125rem 0.4rem 0 0.4rem;
      li {
        width: 100%;
        height: 100%;
        margin-top: 0.1rem;
        border-radius: 0.2rem;
        box-sizing: border-box;
        overflow: hidden;
      }
      .activityProduct {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        .activityProductImg {
          float: left;
          width: 100%;
          img {
            width: 100%;
            height: 3.2rem;
          }
        }
      }
    }
    .shoppingMall {
      overflow: hidden;
      padding: 0.3125rem 0 0 0.3125rem;
      width: 9.2rem;
      height: 2.03rem;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .newProductTop {
      margin: 0 0.4rem;
      .newProduct {
        position: relative;
        margin-top: 0.4rem;
        width: 9.2rem;
        height: 3.44rem;
        background-color: #dbdfe4;
        border-radius: 0.133333rem;
        display: flex;
        .productImg {
          width: 3.066667rem;
          height: 3.066667rem;
          margin: 0.186667rem;
          img {
            width: 3.066667rem;
            height: auto;
          }
        }
        .productText {
          margin-left: 0.213333rem;
          overflow: hidden;
          .p1 {
            margin-top: 0.586667rem;
            font-size: 0.426667rem;
            font-weight: 600;
            color: #333333;
            white-space: nowrap; /*文字不换行*/
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .p2 {
            width: 5.333333rem;
            margin-top: 0.106667rem;
            font-size: 0.32rem;
            font-weight: 400;
            color: #666666;
            //超出文字隐藏------ 需要和这个结合使用
            overflow: hidden;
            //当文本溢出，省略号代替
            text-overflow: ellipsis;
            //文本不会换行，文本会在在同一行上继续，直到遇到 <br> 标签为止。
            white-space: nowrap;
          }
          span {
            display: block;
            margin-top: 0.24rem;
            color: #f5492c;
            font-size: 0.48rem;
            font-weight: 700;
          }
        }
        .btn {
          position: absolute;
          padding: 0 0.4rem;
          height: 0.64rem;
          color: white;
          background-color: #f64a2d;
          border-radius: 0.4rem 0 0 0.4rem;
          font-size: 0.32rem;
          font-weight: 400;
          text-align: center;
          line-height: 0.64rem;
          right: 0;
          bottom: 0.266667rem;
        }
      }
    }
    .secondKill {
      margin-top: 0.4125rem;
      width: 9.2rem;
      height: 0.5rem;
      h4 {
        float: left;
        margin-left: 0.5125rem;
        font-weight: 600;
        color: #000;
        font-size: 0.42rem;
      }
    }
    .productList {
      padding: 0 0.4rem;
      margin: 0 auto;
      margin: 0.27rem 0;
      overflow: hidden;
      ul {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          text-overflow: ellipsis;
          width: 4.4533rem;
          height: auto;
          margin-bottom: 0.266667rem;
          padding-bottom: 0.266667rem;
          border-radius: 0.133333rem;
          overflow: hidden;
          background: rgba(255, 255, 255, 1);
          .productImg {
            text-align: center;
            box-sizing: border-box;
            background-color: #f5f5f5;
            border-radius: 0.1333rem;
            img {
              width: 4.4533rem;
              height: 4.5333rem;
              overflow: hidden;
              display: inherit;
            }
          }
          .proName {
            margin: 0 0.27rem;
            margin-top: 0.15rem;
            .p1 {
              font-size: 0.373333rem;
              color: #333333;
              font-weight: 600;
              white-space: nowrap; /*文字不换行*/
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .p2 {
              font-size: 0.266667rem;
              font-weight: 400;
              color: #666666;
              white-space: nowrap; /*文字不换行*/
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .money {
              display: block;
              margin-top: 0.16rem;
              color: #f5492c;
              font-size: 0.373333rem;
              font-weight: 600;
            }
            .satisfied {
              float: right;
              color: #999999;
              font-size: 0.21rem;
              line-height: 0.8rem;
            }
          }
        }
      }
    }
  }
  .van-loading {
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
  .van-skeleton {
    padding: 0;
  }
}
</style>
